import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import LoyaltyProgram from '../component/LoyaltyProgram/LoyaltyProgram.jsx'

const LoyaltyProgramPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header activeLink={"loyalty"}/>
    <LoyaltyProgram/>
    <Footer/>
    </>
  )
}

export default LoyaltyProgramPage